import { render, staticRenderFns } from "./SearchCardCollection.vue?vue&type=template&id=42fcc3ca&scoped=true&"
import script from "./SearchCardCollection.vue?vue&type=script&lang=js&"
export * from "./SearchCardCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fcc3ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42fcc3ca')) {
      api.createRecord('42fcc3ca', component.options)
    } else {
      api.reload('42fcc3ca', component.options)
    }
    module.hot.accept("./SearchCardCollection.vue?vue&type=template&id=42fcc3ca&scoped=true&", function () {
      api.rerender('42fcc3ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/SearchCardCollection.vue"
export default component.exports